<template>
	<div class="map-part">
		<title1 title="电池信息" subTitle="Battery Information" />
		<div class="contion">
			<infoList class="mt-50" :titleName="'电池信息'" :type="'battery'" :dataList="batteryDataList"></infoList>
			<div class="box mt-60">
				<divBox title="电池寿命预测">
					<myEchart v-if="showcdata1" :id="'socInterval'" :options="cdata1" />
				</divBox>
			</div>
			<title1 class="mt-70" title="交通指标" subTitle="Traffic Index" />
			<div class="box1">
				<divBox class="mt-30" title="SOC值区间">
					<myEchart v-if="showcdata2" :id="'SOCValueRange'" :options="cdata2" />
				</divBox>
			</div>
		</div>
	</div>
</template>

<script>
import infoList from "../infoList";
import divBox from "./divbox2";
import title1 from "@/views/exposition/components/title1";
import bigTitle from "./bigTitle";
import myEchart from "../charts/echarts";
import { dataInterface } from "@/api/dataInterfaceApi";
import * as echarts from "echarts5";

export default {
	components: {
		myEchart,
		bigTitle,
		divBox,
		infoList,
		title1,
	},
	data() {
		return {
			bigtitle1: {
				CHN: "电池指标",
				ENG: "Traffic indicators",
			},
			bigtitle: {
				CHN: "交通指标",
				ENG: "Traffic indicators",
			},
			showcdata1: false,
			cdata1: {
				legend: {
					right: "3%",
					data: ['预测', '实际'],
					icon: 'roundRect',
					itemHeight: 8, // 修改icon图形大小 
					itemWidth: 10
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
				},

				yAxis: {
					type: 'value',
					splitLine: false
				},
				series: [{
					type: 'line',
					smooth: true,
					name: '预测',
					lineStyle: {
						width: 2,
						color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
								offset: 0.1,
								color: '#B8FF7E' // 0% 处的颜色
							},
							{
								offset: 0.9,
								color: '#B8FF7E' // 100% 处的颜色
							}
						])
					},
					itemStyle: {
						normal: {
							color: '#B8FF7E', //改变折线点的颜色
							// lineStyle: {
							// 	color: '#B8FF7E' //改变折线颜色
							// }
						}
					}
				}, {
					type: 'line',
					smooth: true,
					name: '实际',
					lineStyle: {
						width: 2,
						color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
								offset: 0.1,
								color: '#36A1FF' // 0% 处的颜色
							},
							{
								offset: 0.9,
								color: '#36A1FF' // 100% 处的颜色
							}
						])
					},
					itemStyle: {
						normal: {
							color: '#36A1FF', //改变折线点的颜色
							// lineStyle: {
							// 	color: '#B8FF7E' //改变折线颜色
							// }
						}
					}
				}]
			},
			batteryDataList: {},
			showcdata2: false,
			// title:"车辆新增及活跃趋势",
			cdata2: {
				title: {
					text: "%",
				},
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				legend: {
					hidden: true
				},
				xAxis: {
					type: "category",
					boundaryGap: false,
				},
				yAxis: {
					type: "value",
					splitLine: false,
				},
				series: [{
					type: "line",
					name: "SOC值",
					smooth: true,
					areaStyle: {
						normal: {
							color: {
								type: "linear",
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0.1,
										color: "#97DDDE", // 0% 处的颜色
									},
									{
										offset: 0.9,
										color: "#1A2828", // 100% 处的颜色
									},
								],
								globalCoord: false, // 缺省为 false
							},
						},
					},
					itemStyle: {
						normal: {
							color: "#96DDDE", //改变折线点的颜色
							lineStyle: {
								color: "#96DDDE", //改变折线颜色
							},
						},
					},
				}, ],
			},
		};
	},
	props: {
		// cdata: {
		//   type: Object,
		//   default: () => ({}),
		// },
	},
	watch: {},
	mounted() {
		this.getBattery24hours();
		this.getBatteryInfoList();
		this.getBatterySOC();
	},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log("sf123123123123123123123", data);
		},
		//获取24小时电次数分布
		getBattery24hours() {
			let params = {
				"enCode": "per_vehicle-电池寿命预测",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") :
					'LDP31B967MG929008'
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						console.log(res);
						let data = [];
						let xAxis = [];
						let data1 = []
						res.forEach((item) => {
							xAxis.push(item.future_year);
							data.push(item.soh);
							data1.push(item.soh_actual)
						});
						this.cdata1.xAxis.data = xAxis;
						this.cdata1.series[0].data = data;
						this.cdata1.series[1].data = data1
						this.showcdata1 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		//获取电池信息
		getBatteryInfoList() {
			let params = {
				enCode: "per_vehicle-电池编码-生厂商-额定电压-额定容量-质保年限-质保里程-充电电量-累计充电",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ?
					localStorage.getItem("newVehicleNum") :
					"LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					this.batteryDataList = res[0] ? res[0] : {};
				})
				.catch((err) => {
					console.log(err);
				});
		},
		//获取SOC
		getBatterySOC() {
			let params = {
				enCode: "per_vehicle-SOC值区间",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") || "LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						let data = [];
						let xAxis = [];
						res.forEach((item) => {
							xAxis.push(item.cur_date.substr(5, 10));
							data.push(item.avg_soc || 0);
							// xAxis.push(item.down_soc_range)
							// data.push(item.exchange_num)
						});
						this.cdata2.xAxis.data = xAxis;
						this.cdata2.series[0].data = data;
						this.showcdata2 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
// @import './part.scss';
@import '../scss/chd-com.scss';
.contion {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	// flex-wrap: wrap;
	// align-content: stretch;
	// justify-content: space-between;
}

.box {
	width: 430px;
	height: 390px;
}

.box1 {
	margin: 10px 0;
	width: 430px;
	height: 370px;
}
</style>
